/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc
 */
import * as References from './PersonalizationRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#search
 */
export const SEARCH_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_search';
export const SEARCH_QUERY: RegisteredQuery<
  'result',
  References.SearchRequestType,
  References.SearchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: SEARCH_QUERY_FIELD_NAME,
  args: [
    'queryType',
    'search',
    'language',
    'collectionId',
    'filter',
    'sorts',
    'offset',
    'length',
    'suggestionSectionFilter',
    'rankerId',
  ],
  fetcher(
    request: References.SearchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SearchResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.searchRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#autocomplete
 */
export const AUTOCOMPLETE_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_autocomplete';
export const AUTOCOMPLETE_QUERY: RegisteredQuery<
  'result',
  References.AutocompleteRequestType,
  References.AutocompleteResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: AUTOCOMPLETE_QUERY_FIELD_NAME,
  args: [
    'queryTerm',
    'language',
    'fallbackLanguage',
    'limit',
    'useSpellingCorrections',
    'resultTypes',
    'productTypes',
    'rankerId',
  ],
  fetcher(
    request: References.AutocompleteRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.AutocompleteResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.autocompleteRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#getSuggestionSections
 */
export const GET_SUGGESTION_SECTIONS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_getSuggestionSections';
export const GET_SUGGESTION_SECTIONS_QUERY: RegisteredQuery<
  'result',
  References.GetSuggestionSectionsRequestType,
  References.GetSuggestionSectionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SUGGESTION_SECTIONS_QUERY_FIELD_NAME,
  args: [
    'maximumSections',
    'language',
    'minimumSectionCardCount',
    'maximumSectionCardCount',
    'contexts',
    'productTypes',
  ],
  fetcher(
    request: References.GetSuggestionSectionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSuggestionSectionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSuggestionSectionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#getSuggestionSectionsByType
 */
export const GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_getSuggestionSectionsByType';
export const GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY: RegisteredQuery<
  'result',
  References.GetSuggestionSectionsByTypeRequestType,
  References.GetSuggestionSectionsByTypeResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY_FIELD_NAME,
  args: [
    'sectionTypes',
    'language',
    'minimumSectionCardCount',
    'maximumSectionCardCount',
    'contexts',
    'productTypes',
  ],
  fetcher(
    request: References.GetSuggestionSectionsByTypeRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSuggestionSectionsByTypeResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSuggestionSectionsByTypeRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#searchAssets
 */
export const SEARCH_ASSETS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_searchAssets';
export const SEARCH_ASSETS_QUERY: RegisteredQuery<
  'result',
  References.SearchAssetsRequestType,
  References.SearchAssetsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: SEARCH_ASSETS_QUERY_FIELD_NAME,
  args: [
    'language',
    'search',
    'nameSearch',
    'offeringIds',
    'offeringTypes',
    'tiers',
    'absentScopes',
    'businessTypes',
    'pageTypes',
    'pageFeatures',
    'contentTypes',
    'categories',
    'tags',
    'providers',
    'planType',
    'priceRange',
    'minOverallRating',
    'minReviewCount',
    'hasFreeSupport',
    'sorts',
    'slug',
    'length',
    'offset',
    'portalCompatible',
    'searchSource',
    'debug',
  ],
  fetcher(
    request: References.SearchAssetsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SearchAssetsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.searchAssetsRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#getRelevance
 */
export const GET_RELEVANCE_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_getRelevance';
export const GET_RELEVANCE_QUERY: RegisteredQuery<
  'result',
  References.GetRelevanceRequestType,
  References.GetRelevanceResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_RELEVANCE_QUERY_FIELD_NAME,
  args: ['listingId'],
  fetcher(
    request: References.GetRelevanceRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetRelevanceResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getRelevanceRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});
